import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'
import { IListEnergyInvoicesParams, IManualInvoiceParams, ISaveInvoiceParams } from '@/interfaces/api/energyInvoice'

const base = () => `/v1/companies/${getCurrentCompanyId()}/energy_invoices`

const energyInvoiceResource = {
  // Histórico de faturas (mais recente primeiro). Com 2+ UCs, enviar energy_consumer_unit_id.
  list: (params?: IListEnergyInvoicesParams) => ApiService.get(base(), params),
  // Detalhe (inclui fare_items/historical_data).
  get: (id: number) => ApiService.get(`${base()}/${id}`),
  // Salva/atualiza a fatura do mês (idempotente por mês + UC no backend).
  save: (params: ISaveInvoiceParams) => ApiService.post(base(), params),
  // Cadastro manual de fatura antiga (métricas digitadas).
  saveManual: (params: IManualInvoiceParams) => ApiService.post(base(), { source: 'manual', ...params }),
  delete: (id: number) => ApiService.delete(`${base()}/${id}`),
  // Mês de referência vs mesmo mês do ano anterior (escopo por UC).
  comparison: (referenceMonth: string, energyConsumerUnitId?: number) =>
    ApiService.get(`${base()}/comparison`, {
      reference_month: referenceMonth,
      ...(energyConsumerUnitId != null ? { energy_consumer_unit_id: energyConsumerUnitId } : {}),
    }),
}

export default energyInvoiceResource
